module.exports = __webpack_public_path__ + "im.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/im.svg
// module id = 865
// module chunks = 0